import api from "../..";

export const deleteCategory = async ({ id }: { id: number }): Promise<boolean> => {

  return await api.delete(`/categories/${id}/`)
  .then(() => true)
  .catch(() => false);
};